import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { ArrowForward } from '@mui/icons-material';
import { NavLink, useLocation } from 'react-router-dom';

const logo = '/gainss-logo.png';
const perfLogo = '/gainss-perf-logo.png'

function TopNavigation() {
  const location = useLocation();
  const isPerformancePage = location.pathname === '/performance-engineering';

  return (
    <Navbar expand="lg" className="navbar py-3">
      <Container fluid className="px-4">
        <Navbar.Brand href="/">
          <img src={isPerformancePage ? perfLogo : logo} alt="GAINSS" className="navbar-logo" width='162px'/>
        </Navbar.Brand>

        {/* <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="mx-auto align-items-center">
            <NavDropdown
              id="products-dropdown"
              title="Products"
              menuVariant="light"
            >
              <NavDropdown.Item href="#">Product 1</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#">Product 2</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#">Product 3</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown
              id="solutions-dropdown"
              title="Solutions"
              menuVariant="light"
            >
              <NavDropdown.Item href="#">Solution 1</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#">Solution 2</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#">Solution 3</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="#doc">Doc</Nav.Link>
            <Nav.Link href="#pricing">Pricing</Nav.Link>
            <NavDropdown
              id="resources-dropdown"
              title="Resources"
              menuVariant="light"
            >
              <NavDropdown.Item href="#">Resource 1</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#">Resource 2</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#">Resource 3</NavDropdown.Item>
            </NavDropdown>
          </Nav>
          <div className="d-flex align-items-center">
            <Button
              className="nav-btn login-btn"
              variant="outline-primary"
              onClick={handleNavigate}
            >
              Login <ArrowForward fontSize="16px" />
            </Button>
            <Button className="nav-btn try-btn ms-3">
              Try For Free
              <ArrowForward fontSize="16px" />
            </Button>
          </div>
        </Navbar.Collapse> */}
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="mx-auto align-items-center">
            <NavLink
              to="/performance-engineering"
              className="nav-item nav-link">
              Performance Engineering Platform
            </NavLink>
            <NavLink to="/test-intelligence" className="nav-item nav-link">
              Test Intelligence Platform
            </NavLink>
          </Nav>
          <div className="d-flex align-items-center">
            <a
              className="nav-btn login-btn btn btn-outline-primary"
              href={
                isPerformancePage
                  ? 'https://calendly.com/vikas-mittal'
                  : 'https://app.gainss.ai/login'
              }>
              {isPerformancePage ? 'Get Started' : 'Login'}
              <ArrowForward fontSize="16px" />
            </a>
            {!isPerformancePage && (
              <a
                href="https://app.gainss.ai/register"
                className="nav-btn try-btn ms-3 nowrap btn btn-primary">
                Try For Free
                <ArrowForward fontSize="16px" />
              </a>
            )}
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default TopNavigation;
